interface IResellerInfo {
    name: string;
    telephoneNumber?: string;
    address?: string;
    contactEmail?: string;
    erp?: string;
    website?: string;
}

export interface ISystemSettings {
    customCode: string;
    maxPCDistance: number;
    companyName: string;
    companyAddress: string;
    customerPages: string[];
    customExemptHOSName: string;
    customExemptHOSAbbreviation: string;
    allowUnsignedAddIn: boolean;
    jurisdiction: string;
    companyGuid: string;
    resellerInfo?: IResellerInfo;
}

/**
 * The set of fields from SystemSettings consumed by the Drive app.
 * Used as a propertySelector to limit API response payload to only what is needed.
 */
export const SYSTEM_SETTINGS_FIELDS: (keyof ISystemSettings)[] = [
    "customCode",
    "maxPCDistance",
    "companyName",
    "companyAddress",
    "customerPages",
    "customExemptHOSName",
    "customExemptHOSAbbreviation",
    "allowUnsignedAddIn",
    "jurisdiction",
    "companyGuid",
    "resellerInfo"
];

export class SystemSettings implements ISystemSettings {
    customCode: string;
    maxPCDistance: number;
    companyName: string;
    companyAddress: string;
    customerPages: string[];
    customExemptHOSName: string;
    customExemptHOSAbbreviation: string;
    allowUnsignedAddIn: boolean;
    jurisdiction: string;
    companyGuid: string;
    resellerInfo?: IResellerInfo;

    constructor(obj: ISystemSettings) {
        this.customCode = obj.customCode || "";
        this.maxPCDistance = obj.maxPCDistance || 0;
        this.companyName = obj.companyName || "";
        this.companyAddress = obj.companyAddress || "";
        this.customerPages = obj.customerPages || [];
        this.customExemptHOSName = obj.customExemptHOSName || "";
        this.customExemptHOSAbbreviation = obj.customExemptHOSAbbreviation || "";
        this.allowUnsignedAddIn = obj.allowUnsignedAddIn || false;
        this.jurisdiction = obj.jurisdiction || "";
        this.companyGuid = obj.companyGuid || "";
        this.resellerInfo = obj.resellerInfo;
    }
}

export enum SystemSettingsActionTypes {
    SET_SYSTEMSETTINGS = "SET_SYSTEMSETTINGS"
}